/* @flow */

import * as React from 'react';

// $FlowIssue
export default React.createContext(null);
